<template>
    <client-only class="layout-infinite-scroll" v-if="hasMore && loadMore">
        <infinite-loading
            @infinite="loadMore"
            :firstload="firstLoad === undefined || firstLoad"
            target="scroll"
        ></infinite-loading>
        <loading-widget></loading-widget>
    </client-only>
</template>

<script setup lang="ts">
defineProps(['hasMore', 'loadMore', 'firstLoad']);

const infinite = usePluginInfinite();
await infinite.init();
</script>

<style>
@reference "../../assets/main.css";

.layout-infinite-scroll .spinner {
    @apply hidden;
}
</style>
